<div class="container">
    <div class="row">
        <div class="access-denied-content col-xl-6 col-md-10 col-sm-12">
            <p class="c11n-space-stack-2x">
                <c11n-icon
                        [altText]="'error'"
                        [name]="'error-fill'"
                        [scale]="'larger'"
                        class="d-flex justify-content-center c11n-space-stack-3x">
                </c11n-icon>
            </p>
            <h1 class="c11n-text-xl-headline c11n-space-stack-3x" data-cy="page-title">
                {{ content.accessDenied.accessDeniedText }}
            </h1>
            @if (hintParts.length) {
                <p class="c11n-text-md c11n-space-stack-4x">
                    {{ hintParts[0] }}
                    <b>{{ hintParts[1] }}</b>
                    {{ hintParts[2] }}
                    <b>{{ environment.isProduction ? hintParts[4] : hintParts[3] }}</b>
                    {{ hintParts[5] }}
                    <span class="c11n-text-md">
                    <a
                            [attr.href]="environment.SAIL_POINT_URL"
                            [variant]="'primary-reinforced'"
                            c11n-link
                            class="infowave_link"
                            target="_blank"
                            rel="noopener noreferrer"
                    > {{ hintParts[6] }} </a>
                </span>
                    {{ hintParts[7] }}
                </p>
            }
        </div>
    </div>
</div>
